const SHEET_ID = "1JqgexQVBWx7ZkzNuPCdpgU3JiTxU7YILNH6meB5s_iQ";
const BASE_URL = `https://opensheet.elk.sh/${SHEET_ID}`;

export const fetchSheet = async (sheetName) => {
  const res = await fetch(`${BASE_URL}/${sheetName}`);
  if (!res.ok) throw new Error("Failed to fetch sheet");
  return res.json();
};
